import { initializeApp } from "firebase/app";
import { onValue, enableLogging, serverTimestamp } from "firebase/database";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getRef, refs } from "./firebaseRefKit";

// import "firebase/database"
// import "firebase/auth"

const AUTH_TOKEN_KEY = "FirebaseToken";
const configs = {
  DEV: {
    apiKey: "AIzaSyCJZxG-TaPfOA5FQt5SgkTqThJ2g6i5pLQ",
    authDomain: "onemotion-dev.firebaseapp.com",
    databaseURL: "https://onemotion-dev.firebaseio.com",
    projectId: "onemotion-dev",
    storageBucket: "onemotion-dev.appspot.com",
    messagingSenderId: "368996089048",
    appId: "1:368996089048:web:f5fdf32a42206642fc6bad",
    measurementId: "G-C2T5TQ4G16",
  },

  STAGE: {
    apiKey: "AIzaSyAUiB-VuFY2wuQVrZ6zlac3nmjONUH3b_8",
    authDomain: "vvenues-stage.firebaseapp.com",
    databaseURL: "https://vvenues-stage.firebaseio.com",
    projectId: "vvenues-stage",
    storageBucket: "vvenues-stage.appspot.com",
    messagingSenderId: "38149894705",
    appId: "1:38149894705:web:1a25ef0423f05ce2159b10",
    measurementId: "G-5SYLPZYBMX",
  },

  LIVE: {
    apiKey: "AIzaSyDKvE8xcUPXlMPZoWbH5x1w0UID9NEXL7k",
    authDomain: "vvenues-live.firebaseapp.com",
    databaseURL: "https://vvenues-live.firebaseio.com",
    projectId: "vvenues-live",
    storageBucket: "vvenues-live.appspot.com",
    messagingSenderId: "1006903202514",
    appId: "1:1006903202514:web:4b1705ef4956714fcad30b",
    measurementId: "G-LGE9YNSZQH",
  },
};

let app;

export function getConfiguration() {
  if (process.env.NEXT_PUBLIC_ENV === "production") {
    return configs.LIVE;
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    return configs.STAGE;
  } else if (process.env.NEXT_PUBLIC_ENV === "dev") {
    return configs.DEV;
  }
}

// Initialize Firebase
try {
  app = initializeApp(getConfiguration());
  if (
    process.env.NEXT_PUBLIC_ENV === "dev" &&
    process.env.NEXT_PUBLIC_FIREBASE_DEBUG_LOG
  ) {
    enableLogging((message) =>
      console.log(`%c FIREBASE: ${message}`, "background: #222; color: #ffd300")
    );
  }
} catch (error) {
  console.log("Firebase APP already initalized");
}

export default {
  config: {
    getConfiguration,
  },
  announcements: {
    listenToPrivateAnnouncements: (
      eventSlug = "",
      uuid = "",
      onChange = () => {}
    ) => {
      const ref = getRef(refs.$eventSlug.announcements.private.$uuid.results, {
        eventSlug,
        uuid,
      });
      if (ref) onValue(ref, (snapshot) => onChange(snapshot));
    },
    listenToPublicAnnouncements: (eventSlug = "", onChange = () => {}) => {
      const ref = getRef(refs.$eventSlug.announcements.public.results, {
        eventSlug,
      });
      if (ref) onValue(ref, (snapshot) => onChange(snapshot));
    },
    // declinePrivateAnnouncement: (
    //   organizationSlug = "",
    //   eventSlug = "",
    //   pageSlug = "",
    //   eventUserId = ""
    // ) => {
    //   const payload = {

    //   }
    //   firebase
    //     .database()
    //     .ref(`corporate-messages/${organizationSlug}/${eventSlug}/inboxes/${pageSlug}/${eventUserId}/messages`)
    //     .push(payload)
    //   // console.log('announcementId', announcementId)
    //   // console.log('eventSlug', eventSlug)
    //   // console.log('uuid', uuid)
    // }
  },

  util: {
    getServerTimestamp: () => serverTimestamp(),
  },

  auth: {
    signInWithCustomToken: (token) => {
      return new Promise((resolve, reject) => {
        // console.log("SENDING FIREBASE CUSTOM TOKEN", token);
        if (token) {
          try {
            const auth = getAuth();
            signInWithCustomToken(auth, token)
              .then((data) => {
                // console.log('firebase sign-in uid', firebase.auth().currentUser.uid);
                resolve(data);
              })
              .catch((err) => {
                console.error("sign in error", err);
                reject(err);
              });
          } catch (error) {
            console.log(error)
          }
        }
      });
    },
    setToken: (token) => {
      return localStorage.setItem(AUTH_TOKEN_KEY, token);
    },
    getToken: (token) => {
      return localStorage.getItem(AUTH_TOKEN_KEY);
    },
  },
};
